import { LayoutAddiScreenTabletMin, LayoutAddiScreenTabletMax, LayoutAddiScreenDesktopMin, LayoutAddiScreenDesktopMax, LayoutAddiScreenMobileSmallMin, LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
/**
 * @deprecated use @addi/foundation/dist/web/layout instead
 */
export const SCREEN_SIZE = {
    MOBILE: {
        min: LayoutAddiScreenMobileSmallMin,
        max: LayoutAddiScreenMobileLargeMax
    },
    TABLET: {
        min: LayoutAddiScreenTabletMin,
        max: LayoutAddiScreenTabletMax
    },
    // TODO: Look for LAPTOP implementations and replace for DESKTOP
    LAPTOP: {
        min: '1024px',
        max: '1365px'
    },
    DESKTOP: {
        min: LayoutAddiScreenDesktopMin,
        max: '1919px'
    },
    DESKTOP_HD: {
        min: '1920px',
        max: LayoutAddiScreenDesktopMax
    }
};
export var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE["MOBILE"] = "MOBILE";
    DEVICE_TYPE["TABLET"] = "TABLET";
    DEVICE_TYPE["LAPTOP"] = "LAPTOP";
    DEVICE_TYPE["DESKTOP"] = "DESKTOP";
    DEVICE_TYPE["DESKTOP_HD"] = "DESKTOP_HD";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));
export var GRID_COLUMNS;
(function (GRID_COLUMNS) {
    GRID_COLUMNS[GRID_COLUMNS["MOBILE"] = 4] = "MOBILE";
    GRID_COLUMNS[GRID_COLUMNS["TABLET"] = 6] = "TABLET";
    GRID_COLUMNS[GRID_COLUMNS["LAPTOP"] = 12] = "LAPTOP";
    GRID_COLUMNS[GRID_COLUMNS["DESKTOP"] = 12] = "DESKTOP";
    GRID_COLUMNS[GRID_COLUMNS["DESKTOP_HD"] = 12] = "DESKTOP_HD";
})(GRID_COLUMNS || (GRID_COLUMNS = {}));
//# sourceMappingURL=sizes.js.map